/* eslint-disable @typescript-eslint/member-ordering */

import { ChangeDetectionStrategy, Component, inject, model } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UserDto } from 'src/app/api/platform';
import { UsersService } from 'src/app/services/users.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-delete-user-modal',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
  styleUrl: './delete-user-modal.component.scss',
  templateUrl: './delete-user-modal.component.html',
})
export class DeleteUserModalComponent {
  readonly userModel = model<UserDto | null>(null);

  usersService: UsersService;
  toastr: ToastrService;
  modal: NgbActiveModal;

  constructor() {
    this.usersService = inject(UsersService);
    this.toastr = inject(ToastrService);
    this.modal = inject(NgbActiveModal);
  }

  public deleteUser(): void {
    const user = this.userModel();
    if (!user) {
      return;
    }
    try {
      this.usersService.deleteUser(user).subscribe((response) => {
        if (response == 'ok') {
          this.toastr.success('User Deleted');
        }
        this.modal.close();
      });
    } catch (error) {
      this.toastr.error('Error has occurred:', `${error}`);
      this.modal.close();
    }
  }
  public async openCloseDeleteUserModal() {
    this.modal.close();
  }
}
